export default __webpack_public_path__ + "static/dejavu-sans-mono.bold-8608c7eb92d996a15bb3771c8537aad8.ttf";